import { render, staticRenderFns } from "./similarProductsPopup.vue?vue&type=template&id=559d8b18&scoped=true"
import script from "./similarProductsPopup.vue?vue&type=script&lang=js"
export * from "./similarProductsPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559d8b18",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('559d8b18')) {
      api.createRecord('559d8b18', component.options)
    } else {
      api.reload('559d8b18', component.options)
    }
    module.hot.accept("./similarProductsPopup.vue?vue&type=template&id=559d8b18&scoped=true", function () {
      api.rerender('559d8b18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mechanism/components/myDealChild/child/similarProductsPopup.vue"
export default component.exports